import { StrictMode } from 'react';
import { render } from 'react-dom';

import { positions, transitions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";

import App from './modules/App';

import reportWebVitals from './reportWebVitals';

import './index.scss';

const ALERT_OPTIONS = {
  timeout: 5000,
	width: '500px',
  position: positions.TOP_RIGHT,
	transition: transitions.SCALE
};

render(
	<StrictMode>
		<AlertProvider template={AlertTemplate} {...ALERT_OPTIONS}>
			<App />
		</AlertProvider>
	</StrictMode>,
	document.getElementById('root'),
);

reportWebVitals();
